import React, { useEffect } from 'react';
import { Form, Input, Button, Flex } from 'antd';
import ConversionSelect from 'components/Selects/ConversionSelect';
import SymbolsSelect from 'components/Selects/SymbolsSelect';
import { useFormik } from 'formik';
import { StatusSelectFormatter } from 'components/tables/NinjaTable/formatters';

const ConversionRuleForm = ({
  validationSchema,
  initialValues,
  loading,
  rule_id,
  data,
  ButtonText,
  handleConversionRule,
}) => {
  const handleSubmit = () => {
    const {
      id,
      network_conversion_ids,
      object_type,
      operator,
      value,
      statusable_id,
      statusable_type,
    } = form.values;

    const config = {
      id,
      network_conversion_ids,
      object_type,
      statusable_type,
      operator,
      value,
    };

    if (initialValues?.object_type === 'CrmDeal') {
      config.statusable_id = statusable_id;
    }

    handleConversionRule({ config: [config] });
  };

  const form = useFormik({
    initialValues: {
      network_conversion_ids: [],
      operator: '>',
      value: 0,
      ...initialValues,
    },
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (data) {
      form.setValues({ ...data, network_conversion_ids: [data?.network_conversion_id] });
    }
  }, [data, rule_id]);

  const { errors, touched } = form;

  return (
    <div className='mb-4 grid'>
      <Form layout='vertical' onFinish={form.handleSubmit}>
        {initialValues?.object_type === 'CrmDeal' && (
          <Form.Item
            label='Status'
            required
            validateStatus={touched?.statusable_id && errors?.statusable_id ? 'error' : ''}
            help={touched?.statusable_id && errors?.statusable_id}
          >
            <StatusSelectFormatter
              name='statusable_id'
              size='large'
              value={{
                flow_id: form.values.statusable?.flow_id,
                status_id: form.values.statusable?.id,
              }}
              onChange={(val) => {
                form.setFieldValue('statusable_id', val?.status_id);
                form.setFieldValue('statusable.flow_id', val?.flow_id);
                form.setFieldValue('statusable.id', val?.status_id);
              }}
            />
          </Form.Item>
        )}
        <Form.Item
          label='Conversion'
          required
          validateStatus={
            touched.network_conversion_ids && errors.network_conversion_ids ? 'error' : ''
          }
          help={touched.network_conversion_ids && errors.network_conversion_ids}
        >
          <ConversionSelect
            size='large'
            mode='multiple'
            name='network_conversion_ids'
            value={form.values.network_conversion_ids || form.values.network_conversion_id}
            onChange={(val) => form.setFieldValue('network_conversion_ids', val)}
          />
        </Form.Item>
        <Form.Item label='Value'>
          <Input
            size='large'
            placeholder='Value'
            value={form.values.value}
            className='w-full'
            name='value'
            type='number'
            onChange={(e) => form.setFieldValue('value', e.target.value)}
            addonBefore={
              <SymbolsSelect
                value={form.values.operator}
                onChange={(val) => form.setFieldValue('operator', val)}
              />
            }
          />
        </Form.Item>
        <Flex gap='middle' align='center' className='mt-5 m-auto w-fit'>
          <Button type='primary' htmlType='submit' loading={loading}>
            {ButtonText}
          </Button>
        </Flex>
      </Form>
    </div>
  );
};

export default ConversionRuleForm;
